import { render, staticRenderFns } from "./2400_Quiz.vue?vue&type=template&id=eff601e2&lang=pug"
var script = {}
import style0 from "./2400_Quiz.vue?vue&type=style&index=0&id=eff601e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports